import React, { useContext, useEffect, useRef, useState } from 'react';

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
import Swal from 'sweetalert2';
import { AdditionalInfo } from '../components/AdditionalInfo';
import ChildrenData from '../components/ChildrenData';
import CommonAdvantages from '../components/CommonAdvantages';
import ParentData from '../components/ParentData';
import Wishes from '../components/Wishes';
import { AddressContext } from '../contexts/AddressContext';
import { ParameterContext } from '../contexts/ParameterContext';
import { RegisterContext } from '../contexts/RegisterContext';
import { EgnValid } from '../utils/EgnValidator';
import { ManualAddressRegisterBodyFormat, FormatDateyyyyMMdd, StringToDate, StringToDateWithDash } from '../utils/RegisterApplicationBodyFormatter';
import { canShowAdditionalInfo, canShowSchoolsManualAddress, validateTwin, validateDublicateChildrenNames, validateLnchYearsFromSelectedDate, validateWishes } from '../utils/Validations';
import { WishValidatorContext } from '../contexts/WishValidatorContext';
import { AuthContext } from '../contexts/AuthContext';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { createManualAddressApplication, createManualAddressApplicationPredefinedUsers } from '../admin/services/applicationService';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkIsOpenForRegister } from '../admin/services/RankingService';
import { validateCaptcha } from 'react-simple-captcha';
import { SucceedRegistration } from '../components/SucceedRegistration';
export function Register() {

    //Регистрационна форма, която ползва номенклатура за адреси на децата. НЕ СЕ ИЗПОЛЗВА ЗА МОМЕНТА В НИТО ЕДНА ОЩИНА !!!!!!

    const cyrillicRegex = /^(?!\s)(?:[\u0400-\u04FF-]|\s(?!\s))*[\u0400-\u04FF-] ?$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^\d+$/;
    const handleEmailRegex = /[a-zA-Z0-9._%+-@]/

    const parentDataRef = useRef(null);
    const childrenDataRef = useRef(null);
    const commonAdvantagesRef = useRef(null);
    const wishesRef = useRef(null);
    const additionalRef = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();
    const [isOpenForRegister, setIsOpenForRegister] = useState(false);
    const [emptyFields, setEmptyFields] = useState([]);

    const { searchAdvantageSchools,
        validateAddressResidence,
        addressResidence,
        validateSibling,
        streets,
        addressInfo,
        residences,
        getStreetByCode,
        getAddressById,
        getResidences,
        permanentStreetForManualEdit,
        currentStreetForManualEdit,
        currentAddressForManualEdit,
        permanentAddressForManualEdit,
        dontHaveCompletedGroup,
        isChildHavePreparatoryGroup,
        cleanChildHavePreparatoryGroupState,
        siblingIsValid,
        cleanSiblingErrors,
        validateSiblingLnch,
        parentEgnExist,
        getParentDataIfExist,
        parentData,
        checkParentEgnIfExist
    } = useContext(AddressContext);

    const [loading, setLoading] = useState(false);
    const { validateSiblingEGN, removeError } = useContext(WishValidatorContext);
    const { isFormValid, toggleFormToValid, toggleFormToInvalid, commonAdvantages, advantages, schools } = useContext(RegisterContext);
    const { parameters } = useContext(ParameterContext);
    const [mainRegForm, setMainRegForm] = useState(parameters.nomParameters && parameters.nomParameters.find(x => x.param_name == 'MAIN_REGISTER_FORM'));
    const [isAddressesReady, setIsAddressesReady] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState({
        isCurrentAddress: false,
        isPermanentAddress: false
    });
    const [regId, setRegId] = useState(null);
    //Check the context is loaded and if its not set default value until load ParmeterContext
    let stop_reg_dir;
    let autoTimeLived;
    let priemYear;
    let dirDisChildData;
    let maxDesires;

    if (parameters && parameters.nomParameters) {
        const parameterStopRegDir = parameters.nomParameters.find(x => x.param_name == 'STOP_REG_DIR');
        const parameterPriemYear = parameters.nomParameters.find(x => x.param_name == 'PRIEM_YEAR');
        const autoTimeLivedParam = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
        const dirDisableChildData = parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
        const maxDesiresParam = parameters.nomParameters.find(x => x.param_name == 'MAX_DESIRES');

        maxDesires = maxDesiresParam ? maxDesiresParam.value : 10;
        autoTimeLived = autoTimeLivedParam ? autoTimeLivedParam.value : 0;
        stop_reg_dir = parameterStopRegDir ? parameterStopRegDir.value : 0;
        dirDisChildData = dirDisableChildData ? dirDisableChildData.value : 0;
        priemYear = parameterPriemYear ? parameterPriemYear.value : new Date().getFullYear()
    } else {
        stop_reg_dir = 0;
        autoTimeLived = 0;
        priemYear = new Date().getFullYear();
    }

    const { user, sessionToken } = useContext(AuthContext);
    console.log(residences)
    const [formData, setFormData] = useState({
        parentIsEgn: '1',
        parentEgn: '',
        parentName: '',
        parentPhone: '',
        parentEmail: user.role == 'Parent' ? user.email : '',
        childIsEgn: '1',
        childEgn: '',
        childName: '',
        twins: [],
        commonAdvantages: [],
        currentAddress: '',
        currentAddressInfo: { id: '' },
        currentAddressDate: null,
        permanentAddress: '',
        permanentAddressInfo: { id: '' },
        permanentAddressDate: null,
        dontHavePermanentAddress: false,
        dontHaveCurrentAddress: false,
        wishes: [{ id: '', school: '', adv_1: '' }],
        password: '',
        declarationAcc: null,
        captcha: '',
    })
    //console.log('register forma')
    const [verify2FA, setVerify2FA] = useState(false)

    const [errors, setErrors] = useState({});

    useEffect(() => {
        setFormData(state => ({
            ...state,
            commonAdvantages: commonAdvantages.reduce((acc, x) => {
                acc[x.code] = false;
                return acc;
            }, {}),
        }))
    }, [commonAdvantages])

    useEffect(() => {
        setFormData(prevState => {
            const newState = { ...prevState };
            const firstWish = { ...newState.wishes[0] };

            const advantagesMap = advantages.reduce((acc, x) => {
                if (x.code === 'K100') {
                    acc['K100_NAME'] = '';
                    acc['K100_EGN'] = '';
                    acc['K100_IsEgn'] = true;
                } else if (x.code === 'K200') {
                    acc['K200_NAME'] = '';
                    acc['K200_EGN'] = '';
                    acc['K200_IsEgn'] = true;
                } else {
                    acc[x.code] = false;
                }
                return acc;
            }, {});

            newState.wishes[0] = {
                ...firstWish,
                ...advantagesMap,
            };

            return newState;
        });
    }, [advantages])

    useEffect(() => {
        validateWholeForm();

        if (formData.twins.length > 0 && Object.values(formData.twins).some(x => x.twinEgn == '' || x.twinName == '')) {
            toggleFormToInvalid();
        }

        handleErrorLnch();

        console.log('validaciqta ', formData)
    }, [formData])

    useEffect(() => {
        //console.log(formData)
        if (addressResidence.length > 0) {


            getStreetByCode(addressResidence.find(x => x.currenT_ADDR == 2).codE_STREET, true)
            getStreetByCode(addressResidence.find(x => x.currenT_ADDR == 1).codE_STREET, false)

            getAddressById(addressResidence.find(x => x.currenT_ADDR == 2).addresS_ID, addressResidence.find(x => x.currenT_ADDR == 2).codE_NM, true)
            getAddressById(addressResidence.find(x => x.currenT_ADDR == 1).addresS_ID, addressResidence.find(x => x.currenT_ADDR == 1).codE_NM, false)

            setFormData(state => ({
                ...state,
                currentAddressDate: new Date(addressResidence.find(x => x.currenT_ADDR == 2).residence),
                permanentAddressDate: new Date(addressResidence.find(x => x.currenT_ADDR == 1).residence),
            }))

            setErrors(state => ({
                ...state,
                validAddressResidance: null
            }))
        }

        setFormData(state => ({
            ...state,
            wishes: [{ id: '', school: '' }],
        }))
    }, [addressResidence])


    //Зарежда улиците на постоянния и настоящия адрес
    useEffect(() => {
        if (permanentStreetForManualEdit.id && residences.length > 0) {
            setFormData(state => ({
                ...state,
                permanentAddress: permanentStreetForManualEdit,
                permanentChildCity: residences.find(x => x.codeNm == permanentStreetForManualEdit.residenceId)?.nameNm
            }))
        }

        if (currentStreetForManualEdit.id && residences.length > 0) {
            setFormData(state => ({
                ...state,
                currentAddress: currentStreetForManualEdit,
                currentChildCity: residences.find(x => x.codeNm == currentStreetForManualEdit.residenceId)?.nameNm
            }))
        }
    }, [permanentStreetForManualEdit, currentStreetForManualEdit, residences])

    //Зарежда номерата на улиците на постоянния и настоящия адрес
    useEffect(() => {
        setIsAddressesReady(state => !state)

        if (permanentAddressForManualEdit.id) {
            setFormData(state => ({
                ...state,
                permanentAddressInfo: permanentAddressForManualEdit
            }))
        }

        if (currentAddressForManualEdit.id) {
            setFormData(state => ({
                ...state,
                currentAddressInfo: currentAddressForManualEdit
            }))
        }
    }, [permanentAddressForManualEdit, currentAddressForManualEdit])


    useEffect(() => {
        if (formData.currentAddressInfo.id && formData.permanentAddressInfo.id) {
            searchAdvantageSchools(formData.permanentAddressInfo.id, formData.currentAddressInfo.id)
        }
    }, [isAddressesReady])

    useEffect(() => {
        document.title = `Регистрация`;
        setLoading(true)
        const query = new URLSearchParams(location.search);
        if (query.get('regId')) {
            setRegId(query.get('regId'))

            setVerify2FA(true);
        }

        if (!sessionStorage.getItem('sessionToken')) {
            sessionStorage.setItem('sessionToken', sessionToken);
        }

        setTimeout(() => {
            getResidences();
        }, 500)

        checkIsOpenForRegister()
            .then((data) => {

                if (data.status === 400) {
                    setIsOpenForRegister(false);
                }
                else {
                    setIsOpenForRegister(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setIsOpenForRegister(false);
                setLoading(false)
            })
    }, []);

    useEffect(() => {
        validateWholeForm()
    }, [errors, parentEgnExist])

    useEffect(() => {
        if (parentData.egn) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Потребителят вече съществува в системата. Данните за родител ще бъдат автоматично заредени.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            setFormData(state => ({
                ...state,
                parentEgn: parentData.egn,
                parentEmail: parentData.email,
                parentName: parentData.name,
                parentPhone: parentData.phone,
                parentIsEgn: EgnValid(parentData.egn) ? '1' : '0'
            }))
        }
    }, [parentData])

    useEffect(() => {
        const handleClick = (event) => {
            event.preventDefault();
            Swal.close(); // Close the SweetAlert modal
            navigate('/parent-login');
        };

        if (parentEgnExist && !user.token) {
            Swal.fire({
                title: 'Внимание!',
                html: `Родителят вече съществува в системата. Трябва да влезете в своя профил от <a href="/parent-login" id="parent-login-link">ТУК</a>, за да направите нова регистрация на заявление .`,
                icon: 'warning',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                didOpen: () => {
                    document.getElementById('parent-login-link').addEventListener('click', handleClick);
                },
                willClose: () => {
                    const link = document.getElementById('parent-login-link');
                    if (link) {
                        link.removeEventListener('click', handleClick);
                    }
                }
            });
        } else if (parentEgnExist && user.role != 'Parent') {

            getParentDataIfExist(formData.parentEgn)
        } else if (parentEgnExist === false) {

            getParentDataIfExist(formData.parentEgn)
        }
    }, [parentEgnExist]);

    const cleanSiblingInputFields = (e, i, advCode) => {
        setFormData(state => {
            let wishes = [...state.wishes];

            wishes[i][`${advCode}_EGN`] = '';
            wishes[i][`${advCode}_NAME`] = '';

            if (wishes[i][`${advCode}_LnchDate`]) {
                wishes[i][`${advCode}_LnchDate`] = null;
            }

            return { ...state, wishes };
        })
    }

    const validateWholeForm = () => {
        let formDataValues;
        if (parentEgnExist || user.role == 'Parent') {
            formDataValues = Object.keys(formData).filter(key => key !== 'password' && key !== 'parentEgn' && key !== 'parentEmail' && key !== 'parentPhone' && key !== 'parentName').map(key => formData[key]);
        } else {
            formDataValues = Object.values(formData);
        }

        let errosValues = Object.values(errors);


        if (!isFormValid) {
            if (formDataValues.every(x => x !== null && x !== '') && errosValues.every(x => x == null || x == '')) {
                if (validateWishes(formData)
                    && Object.values(dontHaveCompletedGroup).some(x => x == '')
                ) {
                    if (autoTimeLived == 0 && formData.wishes.every(x => x.sedGroup)) {
                        toggleFormToValid();
                        setErrors({});
                    } else if (autoTimeLived == 1) {
                        toggleFormToValid();
                        setErrors({});
                    }

                    //console.log('VALIDNO !')
                }
            }

        }
    }

    const handleErrorLnch = () => {
        if ((formData.childIsEgn == '0' && validateLnchYearsFromSelectedDate(formData.childLnchDate, priemYear)) || formData.childIsEgn == '1') {
            setErrors(state => ({
                ...state,
                childLnchDate: ''
            }))
        } else {

            setErrors(state => ({ ...state, childLnchDate: 'Възрастта на детето е извън възрастовата група за прием в 1 клас!' }))
            toggleFormToInvalid();
        }

        if (formData.twins.length > 0) {
            formData.twins.forEach(x => {
                if ((x.twinIsEgn == '0' && validateLnchYearsFromSelectedDate(x.twinLncDate, priemYear)) || x.twinIsEgn == '1') {
                    setErrors(state => ({
                        ...state,
                        [x.twinNumber]: ''
                    }))
                } else {
                    setErrors(state => ({ ...state, childLnchDate: 'Възрастта на близнака е извън възрастовата група за прием в 1 клас!' }))
                    toggleFormToInvalid();
                }
            })
        }
    }

    const commonAdvatagesChangeHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        setFormData((prevState) => {
            const commonAdvantages = { ...prevState.commonAdvantages };
            commonAdvantages[fieldName] = e.checked;

            return { ...prevState, commonAdvantages };
        });
    }

    const toggleDropDown = (isCurrentAddress) => {
        if (isCurrentAddress) {
            setIsDropdownOpen(state => ({ ...state, isCurrentAddress: !isDropdownOpen.isCurrentAddress }))
        } else {
            setIsDropdownOpen(state => ({ ...state, isPermanentAddress: !isDropdownOpen.isPermanentAddress }))
        }
    }

    const handleChange = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (i !== undefined && fieldName.includes('twin')) {
            setFormData((prevState) => {
                const twins = [...prevState.twins];

                if ((fieldName.includes('Name') && cyrillicRegex.test(fieldValue) || fieldValue == '')) {
                    twins[i][fieldName] = fieldValue.toUpperCase();
                } else if (fieldName.includes('IsEgn')) {
                    setErrors(state => ({ ...state, [`${i}twinEgn`]: '' }))
                    twins[i][fieldName] = fieldValue;
                } else if (fieldName == 'twinLncDate') {
                    twins[i][fieldName] = fieldValue;
                } else if (!fieldName.includes('Name')) {
                    twins[i][fieldName] = fieldValue.trim();
                }

                return { ...prevState, twins };

            });
        } else if (fieldName.includes('Name') || fieldName.includes('NAME')) {
            if (cyrillicRegex.test(fieldValue) || fieldValue == '') {
                setFormData({
                    ...formData,
                    [fieldName]: fieldValue.toUpperCase(),
                });
            }
        }
        else if (fieldName.includes('IsEgn')) {
            fieldName == 'parentIsEgn' ? setErrors(state => ({ ...state, parentEgn: '' })) : setErrors(state => ({ ...state, childEgn: '' }))

            if (fieldName == 'parentIsEgn') {
                setFormData(state => ({
                    ...state,
                    parentIsEgn: fieldValue,
                }))
            } else if (fieldName == 'childIsEgn') {
                setFormData(state => ({
                    ...state,
                    childIsEgn: fieldValue
                }))
            } else {
                setFormData(state => ({
                    ...state,
                    [fieldName]: fieldValue
                }))
            }
        } else if (fieldName === 'currentAddress') {
            debugger

            let newAddress = { id: fieldValue.id, name: fieldValue.name, residenceId: fieldValue.residenceId }
            setFormData(state => ({
                ...state,
                currentAddress: newAddress,
                currentAddressInfo: ''
            }))

            toggleDropDown(true);
        } else if (fieldName === 'permanentAddress') {
            debugger
            let newAddress = { id: fieldValue.id, name: fieldValue.name, residenceId: fieldValue.residenceId }
            setFormData(state => ({
                ...state,
                permanentAddress: newAddress,
                permanentAddressInfo: ''
            }))

            toggleDropDown(false);
        } else if (fieldName == 'declarationAcc') {
            setFormData(state => ({ ...state, [fieldName]: e.checked }))
        } else if (fieldName == 'parentEmail') {
            if (handleEmailRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'parentPhone' || fieldName == 'parentEgn' || fieldName == 'childEgn') {
            if (phoneRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'childLnchDate' || fieldName == 'permanentAddressDate'
            || fieldName == 'currentAddressDate' || fieldName == 'currentAddressInfo'
            || fieldName == 'permanentAddressInfo') {
            debugger

            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue.trim()
            }))
        }


        if (fieldName.includes('currentAddressInfo')) {
            setIsDropdownOpen(state => ({ ...state, isCurrentAddress: false }))
            setIsAddressesReady(state => !state)
        } else if (fieldName.includes('permanentAddressInfo')) {
            setIsDropdownOpen(state => ({ ...state, isPermanentAddress: false }))
            setIsAddressesReady(state => !state)
        }

    }

    const onBlurValidate = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'parentEgn' && formData.parentIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
                checkParentEgnIfExist(fieldValue);
            }
        } else if (fieldName == 'parentEgn' && formData.parentIsEgn == 0) {
            setErrors(state => ({ ...state, [fieldName]: null }))
            checkParentEgnIfExist(fieldValue);
        } else if (fieldName == 'parentEmail') {
            if (!emailRegex.test(fieldValue) && fieldValue != '') {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валиден имейл адрес !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        } else if (fieldName == 'childEgn' && formData.childIsEgn == 1) {
            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        } else if (fieldName == 'password') {
            if (fieldValue.length < 5) {
                toggleFormToInvalid();
            }
        }

        if (user.role == 'Director') {
            if (fieldName == 'childEgn' && EgnValid(fieldValue) && formData.childName.length > 0) {
                validateAddressResidence(fieldValue, formData.childName.trim());
            } else if (fieldName == 'childName' && formData.childName.length > 0 && EgnValid(formData.childEgn)) {
                validateAddressResidence(formData.childEgn, fieldValue.trim());
            } else if (formData.childIsEgn == '0' && fieldName == 'childEgn' && formData.childName.length > 0) {
                validateAddressResidence(fieldValue, formData.childName.trim());
            } else if (fieldName == 'childName' && formData.childName.length > 0 && formData.childIsEgn == '0') {
                validateAddressResidence(formData.childEgn, fieldValue.trim());
            }
        }

    }

    const onBlurTwinHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        let twinValidationError = validateTwin(formData, fieldValue, i);
        if (fieldName == 'twinEgn' && formData.twins[i].twinIsEgn == 1) {

            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
                return
            } else if (twinValidationError) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
                toggleFormToInvalid();
                return
            } else {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
            }
        }

        let dublicatedNamesError = validateDublicateChildrenNames(formData)

        if (twinValidationError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
            toggleFormToInvalid();
        } else if (fieldName == 'twinName' && dublicatedNamesError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: dublicatedNamesError }))
            toggleFormToInvalid();
            return
        } else {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
        }
    }

    const onBlurWishHandler = (e, i, advCode) => {
        if (e.target.name == `${advCode}_EGN`) {
            validateSiblingEGN(e, i, advCode, formData)
        }

        if (formData.wishes[i][`${advCode}_IsEgn`] == 0 && formData.wishes[i][`${advCode}_LnchDate`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSiblingLnch(FormatDateyyyyMMdd(formData.wishes[i][`${advCode}_LnchDate`]), formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
            return
        }

        if (formData.wishes[i][`${advCode}_EGN`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSibling(formData.wishes[i][`${advCode}_EGN`], formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
        }
    }

    const wishChangeHandler = (e, i, advCode) => {
        let fullFieldName = e.target.name;
        let [advName, prop] = e.target.name.split('_');
        let fieldValue = e.target.value;
        let isCheckbox = e.target.type == 'checkbox';

        setFormData((prevState) => {
            let wishes = [...prevState.wishes];

            if (advName == 'school') {
                let isAlreadySelected = false;

                formData.wishes.forEach(x => {
                    if (x.school.id == fieldValue.id) {
                        isAlreadySelected = true;
                        Swal.fire({
                            title: 'Внимание!',
                            text: 'Училището вече е избрано като желание.',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })

                        return;
                    }
                })

                if (isAlreadySelected) {
                    wishes[i][e.target.name] = '';
                    return { ...prevState, wishes };
                }

                for (var key in wishes[i]) {
                    if (key.includes('IsEgn')) {
                        wishes[i][key] = '1';
                    } else if (key.includes('EGN')) {
                        wishes[i][key] = '';
                    } else if (key.includes('NAME')) {
                        wishes[i][key] = '';
                    } else if (key == 'K50') {
                        wishes[i][key] = false;
                        cleanChildHavePreparatoryGroupState(i)
                    }
                }
            }

            if (fullFieldName.includes('NAME') && cyrillicRegex.test(fieldValue) || fieldValue == '') {
                wishes[i][e.target.name] = fieldValue.toUpperCase();
            } else if (fullFieldName.includes('NAME') && !cyrillicRegex.test(fieldValue)) {
                return { ...prevState, wishes };
            } else if (fullFieldName.includes('IsEgn')) {
                removeError(e, i, advCode)
                cleanSiblingErrors(i, advCode)
                cleanSiblingInputFields(e, i, advCode)
                wishes[i][e.target.name] = fieldValue;
            } else if (fullFieldName.includes('EGN')) {
                if (phoneRegex.test(fieldValue) || fieldValue == '') {
                    wishes[i][e.target.name] = fieldValue.trim();
                }
            } else if (fullFieldName.includes('_LnchDate')) {
                wishes[i][e.target.name] = fieldValue;
            } else {
                wishes[i][e.target.name] = isCheckbox ? e.target.checked : fieldValue;
            }


            return { ...prevState, wishes };
        });

        if (isCheckbox && advName == 'K50' && e.target.checked == true) {
            isChildHavePreparatoryGroup(formData.childEgn, formData.childName, formData.wishes[i].school.id, i);
        } else if (isCheckbox && advName == 'K50' && e.target.checked == false) {
            cleanChildHavePreparatoryGroupState(i);
        }


    }

    const checkForParentEmptyFields = (emptyFieldsArr) => {
        if (!formData.parentName) emptyFieldsArr.push(<p key="parentName" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(parentDataRef)}>Данни за родител - Три имена;</p>);
        if (!formData.parentEgn) emptyFieldsArr.push(<p key="parentEgn" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(parentDataRef)}>Данни за родител - ЕГН/ЛНЧ;</p>);
        if (!formData.parentPhone) emptyFieldsArr.push(<p key="parentPhone" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(parentDataRef)}>Данни за родител - Телефон;</p>);
        if (!formData.parentEmail) emptyFieldsArr.push(<p key="parentEmail" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(parentDataRef)}>Данни за родител - Ел.поща;</p>);
    }

    const checkForEmptyFields = () => {
        let emptyFieldsArr = [];

        if (!parentEgnExist && user.role != 'Parent') {
            checkForParentEmptyFields(emptyFieldsArr)
        }

        if (!formData.childEgn) emptyFieldsArr.push(<p key="childEgn" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете - ЕГН/ЛНЧ;</p>);
        if (!formData.childName) emptyFieldsArr.push(<p key="childName" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете - Три имена;</p>);
        if (formData.twins.length > 0) {
            formData.twins.forEach((x, i) => {
                if (!x.twinName) {
                    emptyFieldsArr.push(<p key={`twin${i}name`} className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете - близнак {i + 1}: Три имена;</p>);
                }

                if (!x.twinEgn) {
                    emptyFieldsArr.push(<p key={`twin${i}egn`} className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете - близнак {i + 1}: ЕГН/ЛНЧ;</p>);
                }
            })
        }
        if (formData.wishes.length > 0) {
            formData.wishes.forEach((x, i) => {
                if (!x.school) {
                    emptyFieldsArr.push(<p key={`school`} className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(wishesRef)}>Желание {i + 1} - Училище;</p>);
                }
            })
        }
        if ((!formData.password || formData.password.length < 5) && !parentEgnExist && user.role != 'Parent') {
            emptyFieldsArr.push(<p key="pas" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(additionalRef)}>Парола;</p>);
        }
        if (!formData.declarationAcc) {
            emptyFieldsArr.push(<p key="dec" className="text-danger fw-bold m-0 " style={{ cursor: 'pointer' }} onClick={() => scrollToComponent(additionalRef)}>Прочетох и съм съгласен с условията;</p>);
        }
        setEmptyFields(emptyFieldsArr);
        if (emptyFieldsArr.length > 0) {
            return false;
        }

        return true;
    }

    const clickErrors = (e) => {
        e.preventDefault();

        if (!checkForEmptyFields()) {
            return
        }

        if (!isFormValid || !formData.declarationAcc || Object.values(dontHaveCompletedGroup).some(x => x !== '') || Object.values(siblingIsValid).some(x => x.length > 0) || isTwinsInValid()) {
            Swal.fire({
                title: "Проверете дали всички полета са попълнени!",
                icon: "warning",
            });
            return;
        }

    }

    const onSubmit = (e) => {
        e.preventDefault();

        

        setLoading(true);

        let body;
        if (user.role == 'Director') {
            if (dirDisChildData == 1 && addressResidence.length == 0) {
                body = ManualAddressRegisterBodyFormat(formData, 0, parentEgnExist);
            } else {
                body = ManualAddressRegisterBodyFormat(formData, autoTimeLived, parentEgnExist);
            }
        } else {
            body = ManualAddressRegisterBodyFormat(formData, autoTimeLived, parentEgnExist);
        }

        if (user.role == 'Director' || user.role == 'Municipality'
            || user.role == 'Admin' || user.role == 'SuperAdmin') {
            createManualAddressApplicationPredefinedUsers(body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setVerify2FA(true);
                        setRegId(data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                    setLoading(false);

                })
        } else {
            createManualAddressApplication(body)
                .then((data) => {
                    if (data.status == 400) {
                        Swal.fire({
                            title: 'Внимание!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    } else {
                        setRegId(data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    Swal.fire({
                        title: 'Внимание!',
                        text: err.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                })
        }


    }

    const addTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }
        let twinNumber = newState.twins.length + 1;

        if (twinNumber > 3) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Не може да добавяте повече от три близнака',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        newState.twins.push({ twinNumber, twinIsEgn: formData.parentIsEgn == 0 ? "0" : "1", twinEgn: '', twinName: '' });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        newState.twins.pop();

        toggleFormToInvalid();

        setFormData(newState);
    }

    const addWish = (e) => {
        e.preventDefault();

        console.log('add wish');
        console.log(maxDesires);

        let newState = { ...formData }

        if (newState.wishes.length >= maxDesires) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Достигнали сте максималния брой желания.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        const advantagesMap = advantages.reduce((acc, x) => {
            if (x.code === 'K100') {
                acc['K100_NAME'] = '';
                acc['K100_EGN'] = '';
                acc['K100_IsEgn'] = true;
            } else if (x.code === 'K200') {
                acc['K200_NAME'] = '';
                acc['K200_EGN'] = '';
                acc['K200_IsEgn'] = true;
            } else {
                acc[x.code] = false;
            }
            return acc;
        }, {});

        newState.wishes.push({ id: '', school: '', ...advantagesMap });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeWish = (e, i) => {
        e.preventDefault();
        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да изтриете това желание?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                let newState = { ...formData }

                newState.wishes.pop();

                toggleFormToInvalid();

                setFormData(newState);
            }
        });
    }

    const isTwinsInValid = () => {
        if (formData.twins.length == 0) {
            return false;
        } else if (formData.twins.length > 0 && formData.twins.some(x => x.twinEgn == '' && x.twinName == '')) {
            return true
        } else {
            return false
        }
    }

    const scrollToComponent = (ref) => {
        const scrollToRef = ref.current;
        if (scrollToRef) {
            const elementOffset = scrollToRef.getBoundingClientRect().top;
            const offset = elementOffset - 100;

            const duration = 500;

            const startingY = window.pageYOffset;
            const diff = offset;
            let start;

            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                const time = timestamp - start;
                const percent = Math.min(time / duration, 1);

                window.scrollTo(0, startingY + diff * percent + 70);

                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            });
        }
    };

    return (
        <div className="d-flex container-mob gap-5 w-100-mob m-0-mob">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />

            {(isOpenForRegister && (stop_reg_dir == 0 || user.role != 'Director'))
                ? <>
                    {regId
                        ? <SucceedRegistration user={user} regId={regId} />
                        : <>
                            <div className="form-navigator position-sticky nav-mobile" style={{ top: '50px' }}>
                                <button onClick={() => scrollToComponent(parentDataRef)}>Данни за родител</button>
                                <button onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете</button>
                                <button onClick={() => scrollToComponent(commonAdvantagesRef)}>Предимства</button>
                                {canShowSchoolsManualAddress(formData) && <button onClick={() => scrollToComponent(wishesRef)}>Желания</button>}
                                {canShowAdditionalInfo(formData) && <button onClick={() => scrollToComponent(additionalRef)}>Парола и правила</button>}
                            </div>
                            <div className="w-80 form-body-mob w-100-mob ">
                                <div className="title_entr">Регистрация на заявление</div>
                                <div className="text-center"><a href={`/documents/manuals/manual_parents.pdf`} className="parents-tutorial" target="_blank" rel="noopener noreferrer">Указания за регистрация</a></div>

                                <div className="reg_cont">

                                    <form className="form w-100 d-flex flex-row justify-content-between align-items-center flex-wrap" action="parent_ack" method="post">
                                        {((user.role == 'Director') || (!parentEgnExist && user.role != 'Parent')) &&
                                            <ParentData
                                                ref={parentDataRef}
                                                id='parentData'
                                                formData={formData}
                                                handleChange={handleChange}
                                                onBlurValidate={onBlurValidate}
                                                errors={errors}
                                            />
                                        }
                                        <ChildrenData
                                            ref={childrenDataRef}
                                            id='childrenData'
                                            formData={formData}
                                            handleChange={handleChange}
                                            addTwin={addTwin}
                                            removeTwin={removeTwin}
                                            isDropdownOpen={isDropdownOpen}
                                            toggleDropDown={toggleDropDown}
                                            onBlurValidate={onBlurValidate}
                                            onBlurTwins={onBlurTwinHandler}
                                            errors={errors}
                                        />
                                        <CommonAdvantages
                                            ref={commonAdvantagesRef}
                                            id='commonAdvantages'
                                            formData={formData}
                                            handleChange={commonAdvatagesChangeHandler}
                                        />
                                        {
                                            canShowSchoolsManualAddress(formData) &&
                                            < Wishes
                                                ref={wishesRef}
                                                id='wishes'
                                                formData={formData}
                                                handleChange={handleChange}
                                                wishChangeHandler={wishChangeHandler}
                                                addWish={addWish}
                                                removeWish={removeWish}
                                                cleanSiblingInputFields={cleanSiblingInputFields}
                                                onBlurWishHandler={onBlurWishHandler}
                                            />
                                        }
                                        {
                                            canShowAdditionalInfo(formData) &&
                                            <AdditionalInfo
                                                ref={additionalRef}
                                                formData={formData}
                                                handleChange={handleChange}
                                                onBlurValidate={onBlurValidate}
                                            />
                                        }
                                        {emptyFields.length > 0 && (
                                            <>
                                                <p className="htext_ch">Попълнете следните полета !</p>
                                                <div className="children_data breath" style={{ border: '1px solid red' }}>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {emptyFields}
                                                    </div>
                                                </div>
                                            </>

                                        )}
                                        <div onClick={clickErrors}>
                                            <button
                                                className="btn but_add mb-3 mt-3"
                                                disabled={!isFormValid || !formData.declarationAcc || Object.values(dontHaveCompletedGroup).some(x => x !== '') || Object.values(siblingIsValid).some(x => x.length > 0) || isTwinsInValid()}
                                                onClick={onSubmit}>
                                                Завърши регистрацията.
                                            </button>
                                        </div>
                                    </form>
                                </div>

                            </div>

                        </>
                    }</>
                : <>
                    <div className="reg_cl">Системата e затворена за регистрация и редакция на заявления. </div>
                </>}
        </div>
    );
}

export default Register;